import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={15} fill="none" {...props}>
    <path fill="#FE5000" fillRule="evenodd" d="M16 0H0v12h5l3 3 3-3h5zM3 5h2v2H3zm6 0H7v2h2zm4 0h-2v2h2z" clipRule="evenodd" />
  </svg>
);
export default SvgMessage;
